import React from 'react';
import { CircularProgress } from '@mui/material';
import './loadingIcon.css';
const LoadingIcon = () => {
    return(<div id='loading-icon'>
                <CircularProgress/>
            </div>)
}

export default LoadingIcon;